(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-with-category"] && !Shopify.designMode) return;
  try {
    

    class BlogCategory extends HTMLElement {

        constructor(){
            super();
            
            this.blogContents = this.querySelectorAll('.bc-blog-with-category__blog-list');
            this.blogButtons = this.querySelectorAll('.bc-blog-with-category__category-item');
            this.blogButtons.length && this.blogButtons.forEach(button => {
                button.addEventListener('click', this.open.bind(this));
            });
        }

        open(event){
            
            if(!event.target) return;
            let tabElem = event.target;
            let index = tabElem.getAttribute('data-index');
            
            this.blogButtons.length && this.blogButtons.forEach(tab => {
                if(tab.getAttribute('data-index') === index){
                    tab.classList.add('active');
                } else {
                    tab.classList.remove('active');
                }
            });

            this.blogContents.length && this.blogContents.forEach(content => {
                if(content.getAttribute('data-index') === index){
                    content.classList.add('active');
                } else {
                    content.classList.remove('active');
                }
            });

        }

    };

    customElements.define('blog-category', BlogCategory);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-slider"] && !Shopify.designMode) return;
  try {
     

const slider = document.querySelector('#items');
console.log(slider);
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
  console.log("erreerre", scrollLeft)
});

slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('mousemove', (e) => {
  if (!isDown) return;  // stop the fn from running
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2;
  slider.scrollLeft = scrollLeft - walk;
  
  console.log('sdsd', scrollLeft)
  console.log(slider.scrollLeft)
});


//   touchEvents

slider.addEventListener('touchstart', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener('touchend', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('touchcancel', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider.addEventListener('touchmove', (e) => {
  if (!isDown) return;  // stop the fn from running
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2;
  slider.scrollLeft = scrollLeft - walk;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-template"] && !Shopify.designMode) return;
  try {
    

const signUpButton = document.querySelector('#signUp');
const signInButton = document.querySelector('#signIn');
const container = document.querySelector('#container');
console.log(signUpButton);
signUpButton.addEventListener('click', () => {
	container.classList.add("right-panel-active");
});

signInButton.addEventListener('click', () => {
	container.classList.remove("right-panel-active");
});

const forgotPasswordLink = document.querySelector('.forgot_password');
const containerLogin = document.querySelector('.container-login');
const containerRecover = document.querySelector('#RecoverPasswordForm');
const recoverCancel = document.querySelector('#HideRecoverPasswordLink');
const containerRecover2 = document.querySelector('.recover_password_container');
const signInContainer = document.querySelector('.sign-in-container');
forgotPasswordLink.addEventListener('click', () => {
  containerLogin.classList.add("hide");
  containerRecover.classList.remove("hide");
  containerRecover2.classList.remove("hide");
});
recoverCancel.addEventListener('click', () => {
  containerLogin.classList.remove("hide");
  containerRecover2.classList.add("hide");
});

const customerLoginForm = document.querySelector('#customer_login');
const customerSignupForm = document.querySelector('#create_customer');
customerLoginForm.classList.add("form-login");
customerLoginForm.addEventListener('submit', (e) => {
  e.preventDefault();
});
customerSignupForm.classList.add("form-login");
customerSignupForm.addEventListener('submit', (e) => {
  e.preventDefault();
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-daily-nourish-landing"]) return;
  try {
    
function startTimer(duration, display) {
	var start = Date.now(),
		diff,
		minutes,
		seconds;
	function timer() {
		// get the number of seconds that have elapsed since 
		// startTimer() was called
		diff = duration - (((Date.now() - start) / 1000) | 0);
  
		// does the same job as parseInt truncates the float
		minutes = (diff / 60) | 0;
		seconds = (diff % 60) | 0;
  
		minutes = minutes < 10 ? "0" + minutes : minutes;
		seconds = seconds < 10 ? "0" + seconds : seconds;
  
		display.textContent = minutes + ":" + seconds; 
  
		if (diff <= 0) {
			// add one second so that the count down starts at the full duration
			// example 05:00 not 04:59
			start = Date.now() + 1000;
		}
	};
	// we don't want to wait a full second before the timer starts
	timer();
	setInterval(timer, 1000);
  }
  
  window.onload = function () {
	var fifteenMinutes = 60 * 15,
		display = document.querySelector('#time');
	startTimer(fifteenMinutes, display);
  };
          
const ingredientInfoToggle = document.querySelectorAll('.more_info_btn');
ingredientInfoToggle.forEach(element => {
  console.log(element);
  element.addEventListener('click', () => {
    element.parentElement.parentElement.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-energy-bites-landing"]) return;
  try {
    
function startTimer(duration, display) {
	var start = Date.now(),
		diff,
		minutes,
		seconds;
	function timer() {
		// get the number of seconds that have elapsed since 
		// startTimer() was called
		diff = duration - (((Date.now() - start) / 1000) | 0);
  
		// does the same job as parseInt truncates the float
		minutes = (diff / 60) | 0;
		seconds = (diff % 60) | 0;
  
		minutes = minutes < 10 ? "0" + minutes : minutes;
		seconds = seconds < 10 ? "0" + seconds : seconds;
  
		display.textContent = minutes + ":" + seconds; 
  
		if (diff <= 0) {
			// add one second so that the count down starts at the full duration
			// example 05:00 not 04:59
			start = Date.now() + 1000;
		}
	};
	// we don't want to wait a full second before the timer starts
	timer();
	setInterval(timer, 1000);
  }
  
  window.onload = function () {
	var fifteenMinutes = 60 * 15,
		display = document.querySelector('#time');
	startTimer(fifteenMinutes, display);
  };
          
const ingredientInfoToggle = document.querySelectorAll('.more_info_btn');
ingredientInfoToggle.forEach(element => {
  console.log(element);
  element.addEventListener('click', () => {
    element.parentElement.parentElement.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bkup"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-template"]) return;
  try {
    
const ingredientInfoToggle = document.querySelectorAll('.more_info_btn');
ingredientInfoToggle.forEach(element => {
  console.log(element);
  element.addEventListener('click', () => {
    element.parentElement.parentElement.classList.toggle('active');
  })
})

  } catch(e) { console.error(e); }
})();
})();
